import React from 'react'
import FormLabel from './FormLabel'
import FormField from './FormField'
import styles from './FormDateSelector.module.scss'
import { ReactComponent as CalendarIcon } from 'components/UI/icons/calendar-line.svg'
import PropTypes from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import FormInput from './FormInput'
import { timeConverter2 } from 'components/ContentBox/Online-schedule/components/functions'
import { getLang } from 'hooks/useLocalization'
import kk from 'date-fns/locale/kk'
import DatePickerWrapper from 'components/UI/DatePickerWrapper'
import CustomSelect from 'components/UI/CustomSelect/CustomSelect'
import { monthsData, years } from 'components/UI/Calendar/utils.js'

const formatDateTime = (date) => {
  if (!date) return null

  const year = date.getFullYear()

  // Месяц (01-12)
  const monthNum = date.getMonth() + 1
  const month = monthNum < 10 ? '0' + monthNum : String(monthNum)

  // День (01-31)
  const day = date.getDate()
  const dayFormatted = day < 10 ? '0' + day : String(day)

  // Часы (00-23)
  const hours = date.getHours()
  const hoursFormatted = hours < 10 ? '0' + hours : String(hours)

  // Минуты (00-59)
  const minutes = date.getMinutes()
  const minutesFormatted = minutes < 10 ? '0' + minutes : String(minutes)

  return `${year}-${month}-${dayFormatted} ${hoursFormatted}:${minutesFormatted}`
}

export default function FormDateSelector(props) {
  const onClickButtonHandler = (action) => {
    return action === 'today'
      ? props.onChange(new Date())
      : props.onChange(null)
  }

  registerLocale('kz', kk)

  const DpCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className={styles.inputContainer} onClick={onClick} ref={ref}>
      <CalendarIcon className={styles.calendarIcon} />
      <FormInput isError={props.error}>
        <input
          value={value}
          className={styles.input}
          placeholder={props.placeholder}
          type='text'
          onChange={() => {}}
          readOnly
        />
      </FormInput>
    </div>
  ))

  return (
    <FormField flexBasis={props.flexBasis}>
      <FormLabel isRequired={props.isRequired}>
        {props.label}
        {props.button && (
          <span
            className={styles.action}
            onClick={() => onClickButtonHandler(props.button.action)}
          >
            {props.button.name}
          </span>
        )}
      </FormLabel>
      <DatePickerWrapper>
        <DatePicker
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className={styles.customHeaderSelect}>
              <div className={styles.selectMonth}>
                <div className={styles.dateName}>Месяц</div>
                <CustomSelect
                  options={monthsData}
                  onSelect={(option) => changeMonth(monthsData.indexOf(option))}
                  defaultValue={monthsData[date.getMonth()]}
                />
              </div>
              <div className={styles.selectYear}>
                <div className={styles.dateName}>Год</div>
                <CustomSelect
                  options={years}
                  onSelect={(option) => changeYear(option)}
                  defaultValue={date.getFullYear()}
                />
              </div>
            </div>
          )}
          selected={
            props.selected
              ? new Date(props.selected)
              : props.value
                ? new Date(props.value)
                : null
          }
          /* === БЕЗОПАСНАЯ ЛОГИКА onChange === */
          onChange={(date) => {
            if (!date) {
              props.onChange(null)
              return
            }

            // Если запрошен выбор времени — используем нашу новую функцию
            if (props.showTimeSelect) {
              props.onChange(formatDateTime(date))
            } else {
              // ВО ВСЕХ ОСТАЛЬНЫХ СЛУЧАЯХ — работаем как раньше, ничего не ломаем
              props.onChange(timeConverter2(date))
            }
          }}
          minDate={props.minDate}
          maxDate={props.maxDate}
          excludeDates={props.excludeDates}
          locale={getLang()}
          // Формат отображения в инпуте
          dateFormat={
            props.dateFormat ||
            (props.showTimeSelect ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy')
          }
          // Настройки выбора времени
          showTimeSelect={props.showTimeSelect || false}
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='Время'
          disabled={props.disabled}
          customInput={<DpCustomInput />}
          withPortal
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
        />
      </DatePickerWrapper>
    </FormField>
  )
}

FormDateSelector.propTypes = {
  button: PropTypes.shape({
    name: PropTypes.string,
    action: PropTypes.string,
  }),
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  excludeDates: PropTypes.array,
  flexBasis: PropTypes.string,
  showTimeSelect: PropTypes.bool,
  dateFormat: PropTypes.string,
}
